var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPreloader = function SvgPreloader(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 64,
    height: 64,
    viewBox: "0 0 128 128"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "preloader_svg__a"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#84cee4"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#preloader_svg__a)",
    fillRule: "evenodd",
    d: "M63.85 0A63.85 63.85 0 1 1 0 63.85 63.85 63.85 0 0 1 63.85 0m.65 19.5a44 44 0 1 1-44 44 44 44 0 0 1 44-44"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    dur: "1080ms",
    from: "0 64 64",
    repeatCount: "indefinite",
    to: "360 64 64",
    type: "rotate"
  }))));
};
export default SvgPreloader;